import styles from 'styled-components';

export const StyledAddQueryButton = styles.button`
    color: #525252;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.16px;
    background: transparent;
    border: 0;
    outline: none !important;
    vertical-align: sub;
    height: 100%;
`;